export const ALLOWED_TWILIO_AUDIO_FILE_SIZE_B = 10485760;

export const TWILIO_FILE_SIZE_EXCEEDED_DEFAULT_ERROR_MESSAGE = 'This file must be less than 10 MB';

export const BROWSER_MIME_MAP = {
  'audio/wav': 'audio/vnd.wave',
};

export const SUPPORTED_MIME_TYPES = [
  'audio/mpeg',
  'audio/vnd.wave',
  'audio/aac',
  'audio/3gpp',
  'audio/3gpp2',
  'audio/ogg',
  'audio/vorbis',
  'audio/opus',
  'audio/webm',
];
